import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { Paginator, QcResponseGrid } from 'src/app/shared/models/grid.model';
import { Language, Literals } from '../models/literals.model';

export const PanelStatusChanged = createAction('[Literals: Search]: Panel Status Changed');

export const GetSearchLiterals = createAction('[Literals: Search]: Get Literals');

export const GetSearchLiteralsSuccess = createAction(
  '[Literals: Search]: Get Literals Success',
  props<{ res: Literals[] }>(),
);

export const GetSearchLiteralsFailed = createAction(
  '[Literals: Search]: Get Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const RefreshLiterals = createAction('[Literals: Search]: Refresh Literals');

export const RefreshSystemsLiterals = createAction('[Literals: Search]: Refresh Systems Literals');

export const LiteralCodeChanged = createAction(
  '[Literals: Search]: Literal Code Changed',
  props<{ literalCode: string }>(),
);

export const LiteralTextChanged = createAction(
  '[Literals: Search]: Literal Text Changed',
  props<{ literalText: string }>(),
);

export const ClearSearchLiteralsFilters = createAction(
  '[Literals: Search]: Clear Search Literals Filters',
);

export const EditLiteral = createAction('[Literals: Search]: Edit Literal', props<{ row: any }>());

export const GetAvailableLanguages = createAction('[Literals: Search]: Get Available Languages');

export const GetAvailableLanguagesSuccess = createAction(
  '[Literals: Search]: Get Available Languages Success',
  props<{ res: Language[] }>(),
);

export const GetAvailableLanguagesFailed = createAction(
  '[Literals: Search]: Get Available Languages Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const CreateNewLiteral = createAction('[Literals: Search]: Create New Literal');

export const RefreshCustomLiterals = createAction('[Literals: Search]: Refresh Custom Literals');

export const RefreshCustomLiteralsSuccess = createAction(
  '[Literals: Search]: Refresh Custom Literals Success',
  props<{ res: QcResponseGrid }>(),
);

export const RefreshCustomLiteralsFailed = createAction(
  '[Literals: Search]: Refresh Custom Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const RefreshCoreLiterals = createAction('[Literals: Search]: Refresh Core Literals');

export const RefreshCoreLiteralsSuccess = createAction(
  '[Literals: Search]: Refresh Core Literals Success',
  props<{ res: QcResponseGrid }>(),
);

export const RefreshCoreLiteralsFailed = createAction(
  '[Literals: Search]: Refresh Core Literals Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const FindLiteralsByLanguage = createAction('[Literals: Search]: Find Literals By Language');

export const FindLiteralsByLanguageSuccess = createAction(
  '[Literals: Search]: Find Literals By Language Success',
  props<{ res: any }>(),
);

export const FindLiteralsByLanguageFailed = createAction(
  '[Literals: Search]: Find Literals By Language Failed',
  props<{ error: HttpErrorResponse }>(),
);

export const SearchLiteralsByFilter = createAction('[Literals: Search]: Search Literals By Filter');

export const SearchLiteralsByFilterSuccess = createAction(
  '[Literals: Search]: Search Literals By Filter Success',
  props<{ res: any }>(),
);

export const SearchLiteralsByFilterFailed = createAction(
  '[Literals: Search]: Search Literals By Filter Failed',
  props<{ rror: HttpErrorResponse }>(),
);

export const SearchLiteralsGridSuccess = createAction(
  '[Literals: Search]: Search Literals Grid Success',
  props<{ res: any }>(),
);

export const LiteralsPerPageChanged = createAction(
  '[Literals: Search]: Literals Per Page Changed',
  props<{ itemsNumber: number }>(),
);

export const LiteralsPagingChanged = createAction(
  '[Literals: Search]: Literals Paging Changed',
  props<{ paginator: Paginator }>(),
);

export const LiteralsData = createAction(
  '[Literals: Search]: Literals Data',
  props<{ literalsData: any }>(),
);
